import angular from 'angular';
import csmCommonWeb from 'csm-common-web';

import booksSvc from '../../util/BooksSvc/BooksSvc';

// TODO PK
// I altered some imports here cuz they were circular - importing BooksWeb etc. Might break but wont know until we
// convert the whole module and test it.
// angular.module("books.dialogs.addChangeFundraiserDialog", ["CSMBooksWeb", 'ui.bootstrap', "books.util.BooksSvc"])

export default angular
  .module('books.dialogs.addChangeFundraiserDialog', [
    csmCommonWeb,
    // 'CSMBooksWeb',
    'ui.bootstrap',
    booksSvc
  ])
  /* @ngInject */
  .service('AddChangeFundraiserDialog', function ($uibModal, SERVER) {
    /*****************************************************************************
     * show */
    /**
     * Displays a modal to manage the provided fundraiser object. If no object is
     * provided a new fundraiser is to be managed. The resolved promise will contain
     * the saved fundraiser.
     *
     * @param  fundraiserID FundraiserID to modify. Null/0 = new.
     * @param  name         Optional name to preset for new fundraisers
     * @return              Promise to listen for saved fundraiser
     *****************************************************************************/
    this.show = function (fundraiserID, name) {
      return $uibModal.open({
        size: 'md',
        backdrop: 'static',
        template:
          '<add-change-class-dialog class="fundraiser" class-label="Fundraiser" cancel="$dismiss()" commit="save()"></add-change-class-dialog>',
        controller: function ($scope, Alert, BusyScreen, BooksSvc) {
          /***********************************************************************
           * save */
          /**
           * Saves the fundraiser and resolves the modal with the updated fundraiser.
           ***********************************************************************/
          $scope.save = function () {
            BusyScreen.setBusy(true);
            BooksSvc.saveFundraiser($scope.fundraiser)
              .then(
                function (resp) {
                  $scope.fundraiser.id = Number(resp.data);

                  /*------------------------------*/
                  /* Ensure the class type is set */
                  /*------------------------------*/
                  $scope.fundraiser.type =
                    SERVER.BooksDBConstants.CT_FUNDRAISER;

                  $scope.$close($scope.fundraiser);
                },

                /*--------------------*/
                /* Show error message */
                /*--------------------*/
                function (resp) {
                  Alert.error(
                    resp.parsedResponse
                      ? resp.parsedResponse.message()
                      : resp.statusText,
                    'Cannot Save'
                  );
                }
              )
              .finally(function () {
                BusyScreen.setBusy(false);
              });
          };

          /*----------------------------------------------*/
          /* Initialize fundraiser model. If an ID was    */
          /* passed, load the fundraiser from the server, */
          /* otherwise set up a new fundraiser object.    */
          /*----------------------------------------------*/
          if (!fundraiserID) $scope.fundraiser = { name: name };
          else {
            BusyScreen.setBusy(true);
            BooksSvc.getFundraiser(fundraiserID).then(function (resp) {
              $scope.fundraiser = resp.data || { name: name };

              BusyScreen.setBusy(false);
            });
          }
        }
      }).result;
    };
  }).name;
